'use client'

import FavoritesGames from 'pageContainers/FavoritesGames'
import { useAppSelector } from 'src/store/hooks'
import { favoritesLayoutSelector, visibleFavoritesGamesSelector } from 'src/store/modules/favorites/selectors'

import t from '../utils/getTranslationClient'

export default function Games() {
  const games = useAppSelector(visibleFavoritesGamesSelector)
  const layout = useAppSelector(favoritesLayoutSelector)

  return <FavoritesGames games={games} title={t('my_slot_games')} layout={layout} />
}
